<template>
  <van-sticky :offset-top="0">
    <div class="count-down">
      <!-- 活动倒计时 -->
      <span class="count-down-text">距离结束剩余</span>
      <van-count-down :time="time" format="DD 天 HH 时 mm 分 ss 秒" />
    </div>
  </van-sticky>
</template>
<script>
export default {
  name: 'countDown',
  props: {
    time: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
    }
  }

}
</script>
<style lang="stylus" scoped>
  .count-down {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #A2160A;
    padding: 12px 0;
    box-sizing: border-box;
    color: #fff;
  }
  .count-down-text {
    font-size: 24px;
    line-height: 20px;
    margin-right: 10px;
    font-font-family: PingFangSC-Regular;
  }
  /deep/.van-count-down {
    font-size: 0.64rem;
    
    color: #fff;
    font-font-family: PingFangSC-Regular;
  }
</style>